/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';
import { Skeleton } from 'react-skeleton-generator';
import {
    ShimmerBadge, ShimmerButton, ShimmerTitle,
} from 'react-shimmer-effects';
import ProductSkeleton from '../../../../Components/ProductCard/ProductSkeleton';

function ProductListSkeleton() {
    return (
        <Skeleton.SkeletonThemeProvider>
            <div class="flex">
                <div class="xl:block bg-[#FFFFFF] pl-6 pr-3.5 pt-[26px] pb-[100px] border-r border-[#A5A5A5]  main-screen h-screen ">
                    <div class="flex justify-between items-center">
                        <p class="text-lg font-bold text-[#15090E]"><Skeleton height="15px" width="100px" /></p>
                        <p class="text-sm30 text-[#ED1C24] cursor-pointer"><Skeleton height="15px" width="100px" /></p>
                    </div>

                    <div class="pt-3.5">
                        <p class="text-sm31 font-medium text-[#555259] relative"><Skeleton height="15px" width="100px" /></p>
                        <div class="h-[230px] overflow-auto mt-[26px] sidebar">
                            <button class="transition duration-150 ease-in-out flex items-center pt-3.5 drop-rotate" type="button" data-bs-toggle="collapse" data-bs-target="#collapsecat9" aria-expanded="false" aria-controls="collapsecat9">
                                <div class="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 flex items-center">
                                    <label for="cd20" class="pl-3 text-sm font-bold text-[#808285]"><Skeleton height="15px" width="100px" /></label>
                                </div>
                            </button>
                            <button class="transition duration-150 ease-in-out flex items-center pt-3.5 drop-rotate" type="button" data-bs-toggle="collapse" data-bs-target="#collapsecat10" aria-expanded="false" aria-controls="collapsecat10">
                                <div class="relative checkbox custom-checkbox custom-checkbox2 custom-checkbox3 flex items-center">
                                    <label for="cd21" class="pl-3 text-sm font-bold text-[#808285]"><Skeleton height="15px" width="100px" /></label>
                                </div>
                            </button>
                        </div>
                        <div class="pt-3">
                            <p class="text-xs7 font-bold text-[#555259]"><Skeleton height="15px" width="80px" /></p>
                            <div class="flex pt-1.5 -mx-2.5">
                                <div class="flex flex-col w-1/2 relative px-2.5">
                                    <label for="Diameter" class="text-xs12 font-normal text-[#555259] pb-1.5 diameter"><Skeleton height="12px" width="50px" /></label>
                                    <div class="dropdown relative">
                                        <button type="button" id="diameter" data-bs-toggle="dropdown" aria-expanded="false" class="dropdown-diameter flex border border-[#A5A5A5] px-1.5 rounded-[6px] items-center" />
                                        <Skeleton height="18px" width="110px" />
                                    </div>
                                </div>
                                <div class="flex flex-col w-1/2 px-2.5 relative">
                                    <label for="length" class="text-xs12 font-normal text-[#555259] pb-1.5 diameter"><Skeleton height="12px" width="50px" /></label>
                                    <div class="dropdown relative">
                                        <button type="button" id="selectlength" data-bs-toggle="dropdown" aria-expanded="false" class="dropdown-length flex  border border-[#A5A5A5] rounded-[6px] px-1.5 items-center">
                                            <p class="text-sm32 font-semibold text-[#555259] pr-6 py-1.5 "><Skeleton height="18px" width="110px" /></p>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p class="text-xs7 font-bold mt-[30px] text-[#555259]"><Skeleton height="18px" width="110px" /></p>
                        <div class="relative">
                            <div class="pt-3.5 flex justify-between">
                                <p class="text-xs font-semibold text-[#000000]"><Skeleton height="12px" width="60px" /></p>
                                <p class="text-xs font-semibold text-[#000000]"><Skeleton height="12px" width="60px" /></p>
                            </div>
                            <div class=" mt-2 mb-4">
                                <Skeleton height="12px" width="245px" />
                            </div>
                        </div>
                        <div class="px-1 flex items-center">
                            <div class="relative w-1/2">
                                <Skeleton height="18px" width="115px" />
                            </div>
                            <span class="text-xs6 font-semibold text-[#000000] px-5">-</span>
                            <div class="relative w-1/2">
                                <Skeleton height="18px" width="115px" />
                            </div>
                        </div>
                    </div>
                    <div class="pt-32">
                        <Skeleton height="28px" width="245px" />
                    </div>
                </div>
                <div class="xl:w-[80%] lg:px-[18px] md:px-[46px] px-4 pb-10 overflow-auto h-[800px]">
                    <div class="w-full">
                        <div class="flex  justify-between items-center">
                            <p class="text-sm34 font-semibold text-[#090406]"><Skeleton height="18px" width="115px" /></p>
                            <div class="flex items-center justify-between ml-2">
                                <div class="relative mr-2">
                                    <Skeleton height="25px" width="155px" />
                                </div>
                                <div class="bg-[#F5F5FA] flex items-center rounded-md py-2 w-fit px-4 ">
                                    <div class="dropdown relative">
                                        <Skeleton height="25px" width="155px" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <!-- product list and info section --> */}
                        <div class="pt-[18px]">
                            <div class="rounded-lg bg-[#FFFFFF] shadow-s7 pt-2 sm:pb-2.5 pb-2 sm:pl-3 sm:pr-4 px-2.5 relative">
                                <div class="flex flex-wrap">
                                    <div class="lg:w-[65%] w-full pt-2">
                                        <div class="flex">
                                            <div class="w-1/4">
                                                <Skeleton height="75px" width="155px" />
                                            </div>
                                            <div class="pl-2.5">
                                                <div class="flex sm:items-center items-start sm:flex-row flex-col">
                                                    <p class="sm:text-xl text-base font-bold text-[#090406] pr-3"><Skeleton height="18px" width="155px" /></p>
                                                    <p class="text-xs font-semibold text-[#FFFFFF] rounded px-1.5 py-1 w-fit sm:mt-0 mt-1"><Skeleton height="18px" width="105px" /></p>
                                                </div>
                                                <p class="sm:text-xs6 text-xs2 font-normal text-[#808285] mt-1">
                                                    <span><Skeleton height="18px" width="300px" /></span>
                                                </p>

                                            </div>

                                        </div>
                                        <div class="mt-2 pl-4 flex sm:items-center items-baseline sm:flex-row flex-col">
                                            <Skeleton height="18px" width="600px" />
                                        </div>
                                        <div class="lg:w-[70%] w-full sm:pl-4">
                                            <p class="sm:text-base text-xs6 font-normal text-[#808285] sm:pt-1 pt-2">
                                                {' '}
                                                <Skeleton height="35px" width="700px" />
                                            </p>
                                        </div>
                                    </div>
                                    <div class="lg:w-[35%] w-full lg:pt-0 pt-5">
                                        <div>
                                            <div class="bg-[#EAEAF0] rounded-md p-4 w-full mt-1.5">
                                                <div class="flex">
                                                    <div class="w-1/2 pr-1">
                                                        <p class="text-xs font-semibold text-[#616874] pb-2"><Skeleton height="15px" width="120px" /></p>
                                                        <p class="sm:text-xs6 text-sm font-semibold text-[#555259]"><Skeleton height="15px" width="60px" /></p>
                                                    </div>
                                                    <div class="w-1/2 pr-1">
                                                        <p class="text-xs font-semibold text-[#616874] pb-2"><Skeleton height="15px" width="120px" /></p>
                                                        <p class="sm:text-xs6 text-sm font-semibold text-[#555259]"><Skeleton height="15px" width="60px" /></p>
                                                    </div>
                                                </div>
                                                <div class="flex pt-4">
                                                    <div class="w-1/2 pr-1">
                                                        <p class="text-xs font-semibold text-[#616874] pb-2"><Skeleton height="15px" width="120px" /></p>
                                                        <p class="sm:text-xs6 text-sm font-semibold text-[#555259]"><Skeleton height="15px" width="60px" /></p>
                                                    </div>
                                                    <div class="w-1/2 pr-1">
                                                        <p class="text-xs font-semibold text-[#616874] pb-2"><Skeleton height="15px" width="120px" /></p>
                                                        <p class="sm:text-xs6 text-sm font-semibold text-[#555259]"><Skeleton height="15px" width="60px" /></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-2.5 flex items-center">
                                    <div class="lg:w-[65%] w-full pl-4">
                                        <p class="sm:text-xs6 text-xs2 font-semibold text-[#808285] pb-2"><Skeleton height="15px" width="90px" /></p>
                                        <p class="md:text-xs11 sm:text-xl text-lg font-semibold text-[#15090E]"><Skeleton height="18px" width="120px" /></p>
                                    </div>
                                    <div class="lg:w-[35%] w-full">
                                        <Skeleton height="35px" width="350px" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pt-[18px]">
                            <div class="rounded-lg bg-[#FFFFFF] shadow-s7 pt-2 sm:pb-2.5 pb-2 sm:pl-3 sm:pr-4 px-2.5 relative">
                                <div class="flex flex-wrap">
                                    <div class="lg:w-[65%] w-full pt-2">
                                        <div class="flex">
                                            <div class="w-1/4">
                                                <Skeleton height="75px" width="155px" />
                                            </div>
                                            <div class="pl-2.5">
                                                <div class="flex sm:items-center items-start sm:flex-row flex-col">
                                                    <p class="sm:text-xl text-base font-bold text-[#090406] pr-3"><Skeleton height="18px" width="155px" /></p>
                                                    <p class="text-xs font-semibold text-[#FFFFFF] rounded px-1.5 py-1 w-fit sm:mt-0 mt-1"><Skeleton height="18px" width="105px" /></p>
                                                </div>
                                                <p class="sm:text-xs6 text-xs2 font-normal text-[#808285] mt-1">
                                                    <span><Skeleton height="18px" width="300px" /></span>
                                                </p>

                                            </div>

                                        </div>
                                        <div class="mt-2 pl-4 flex sm:items-center items-baseline sm:flex-row flex-col">
                                            <Skeleton height="18px" width="600px" />
                                        </div>
                                        <div class="lg:w-[70%] w-full sm:pl-4">
                                            <p class="sm:text-base text-xs6 font-normal text-[#808285] sm:pt-1 pt-2">
                                                {' '}
                                                <Skeleton height="35px" width="700px" />
                                            </p>
                                        </div>
                                    </div>
                                    <div class="lg:w-[35%] w-full lg:pt-0 pt-5">
                                        <div>
                                            <div class="bg-[#EAEAF0] rounded-md p-4 w-full mt-1.5">
                                                <div class="flex">
                                                    <div class="w-1/2 pr-1">
                                                        <p class="text-xs font-semibold text-[#616874] pb-2"><Skeleton height="15px" width="120px" /></p>
                                                        <p class="sm:text-xs6 text-sm font-semibold text-[#555259]"><Skeleton height="15px" width="60px" /></p>
                                                    </div>
                                                    <div class="w-1/2 pr-1">
                                                        <p class="text-xs font-semibold text-[#616874] pb-2"><Skeleton height="15px" width="120px" /></p>
                                                        <p class="sm:text-xs6 text-sm font-semibold text-[#555259]"><Skeleton height="15px" width="60px" /></p>
                                                    </div>
                                                </div>
                                                <div class="flex pt-4">
                                                    <div class="w-1/2 pr-1">
                                                        <p class="text-xs font-semibold text-[#616874] pb-2"><Skeleton height="15px" width="120px" /></p>
                                                        <p class="sm:text-xs6 text-sm font-semibold text-[#555259]"><Skeleton height="15px" width="60px" /></p>
                                                    </div>
                                                    <div class="w-1/2 pr-1">
                                                        <p class="text-xs font-semibold text-[#616874] pb-2"><Skeleton height="15px" width="120px" /></p>
                                                        <p class="sm:text-xs6 text-sm font-semibold text-[#555259]"><Skeleton height="15px" width="60px" /></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-2.5 flex items-center">
                                    <div class="lg:w-[65%] w-full pl-4">
                                        <p class="sm:text-xs6 text-xs2 font-semibold text-[#808285] pb-2"><Skeleton height="15px" width="90px" /></p>
                                        <p class="md:text-xs11 sm:text-xl text-lg font-semibold text-[#15090E]"><Skeleton height="18px" width="120px" /></p>
                                    </div>
                                    <div class="lg:w-[35%] w-full">
                                        <Skeleton height="35px" width="350px" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pt-[18px]">
                            <div class="rounded-lg bg-[#FFFFFF] shadow-s7 pt-2 sm:pb-2.5 pb-2 sm:pl-3 sm:pr-4 px-2.5 relative">
                                <div class="flex flex-wrap">
                                    <div class="lg:w-[65%] w-full pt-2">
                                        <div class="flex">
                                            <div class="w-1/4">
                                                <Skeleton height="75px" width="155px" />
                                            </div>
                                            <div class="pl-2.5">
                                                <div class="flex sm:items-center items-start sm:flex-row flex-col">
                                                    <p class="sm:text-xl text-base font-bold text-[#090406] pr-3"><Skeleton height="18px" width="155px" /></p>
                                                    <p class="text-xs font-semibold text-[#FFFFFF] rounded px-1.5 py-1 w-fit sm:mt-0 mt-1"><Skeleton height="18px" width="105px" /></p>
                                                </div>
                                                <p class="sm:text-xs6 text-xs2 font-normal text-[#808285] mt-1">
                                                    <span><Skeleton height="18px" width="300px" /></span>
                                                </p>

                                            </div>

                                        </div>
                                        <div class="mt-2 pl-4 flex sm:items-center items-baseline sm:flex-row flex-col">
                                            <Skeleton height="18px" width="600px" />
                                        </div>
                                        <div class="lg:w-[70%] w-full sm:pl-4">
                                            <p class="sm:text-base text-xs6 font-normal text-[#808285] sm:pt-1 pt-2">
                                                {' '}
                                                <Skeleton height="35px" width="700px" />
                                            </p>
                                        </div>
                                    </div>
                                    <div class="lg:w-[35%] w-full lg:pt-0 pt-5">
                                        <div>
                                            <div class="bg-[#EAEAF0] rounded-md p-4 w-full mt-1.5">
                                                <div class="flex">
                                                    <div class="w-1/2 pr-1">
                                                        <p class="text-xs font-semibold text-[#616874] pb-2"><Skeleton height="15px" width="120px" /></p>
                                                        <p class="sm:text-xs6 text-sm font-semibold text-[#555259]"><Skeleton height="15px" width="60px" /></p>
                                                    </div>
                                                    <div class="w-1/2 pr-1">
                                                        <p class="text-xs font-semibold text-[#616874] pb-2"><Skeleton height="15px" width="120px" /></p>
                                                        <p class="sm:text-xs6 text-sm font-semibold text-[#555259]"><Skeleton height="15px" width="60px" /></p>
                                                    </div>
                                                </div>
                                                <div class="flex pt-4">
                                                    <div class="w-1/2 pr-1">
                                                        <p class="text-xs font-semibold text-[#616874] pb-2"><Skeleton height="15px" width="120px" /></p>
                                                        <p class="sm:text-xs6 text-sm font-semibold text-[#555259]"><Skeleton height="15px" width="60px" /></p>
                                                    </div>
                                                    <div class="w-1/2 pr-1">
                                                        <p class="text-xs font-semibold text-[#616874] pb-2"><Skeleton height="15px" width="120px" /></p>
                                                        <p class="sm:text-xs6 text-sm font-semibold text-[#555259]"><Skeleton height="15px" width="60px" /></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="mt-2.5 flex items-center">
                                    <div class="lg:w-[65%] w-full pl-4">
                                        <p class="sm:text-xs6 text-xs2 font-semibold text-[#808285] pb-2"><Skeleton height="15px" width="90px" /></p>
                                        <p class="md:text-xs11 sm:text-xl text-lg font-semibold text-[#15090E]"><Skeleton height="18px" width="120px" /></p>
                                    </div>
                                    <div class="lg:w-[35%] w-full">
                                        <Skeleton height="35px" width="350px" />
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </Skeleton.SkeletonThemeProvider>

    );
}

export default ProductListSkeleton;
